import React, { useState, useEffect } from "react";
import _ from "lodash";
import { Slider } from "@mui/material";
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import { IconButton } from '@mui/material';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Search from './Search';
import CanvasPoints from './CanvasRender';
// import cardData from '../data/onlyCoords.json';
import pako from 'pako';

const file = '../data/onlyCoords.json';
const VALUES = {
    width: file === '../data/onlyCoordsSmall.json' ? 180 : 200,
    height: file === '../data/onlyCoordsSmall.json' ? 266 : 280,
    radius: file === '../data/onlyCoordsSmall.json' ? 2 : 0.2,
    scaleExtent: file === '../data/onlyCoordsSmall.json' ? [-5, 20] : [-5, 500],
    zoomDisplayImages: file === '../data/onlyCoordsSmall.json' ? 10 : 100,
    zoomScale: file === '../data/onlyCoordsSmall.json' ? 11 : 200,
    transitionTime: file === '../data/onlyCoordsSmall.json' ? 1350 : 6350,
    zoomDeletePoints: file === '../data/onlyCoordsSmall.json' ? -100 : 40,
};

const DISPLAYS = {
  color: 'color',
  display: 'display',
  keyword: 'keyword',
  power: 'power',
  text: 'text',
  type: 'type',
}

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

async function fetchAndDecompressData() {
  // const response = await fetch('https://storage.googleapis.com/imatges-mtg/onlyCoordsMinR.json.gz');
  const response = await fetch('https://martirubiobucket-mtg.s3.eu-central-1.amazonaws.com/onlyCoordsMinR.json.gz');
  const compressedData = await response.arrayBuffer();
  const decompressedData = pako.inflate(new Uint8Array(compressedData), { to: 'string' });
  const parsed = JSON.parse(decompressedData);
  return parsed;
}

// const MTGMap = ({setCardNames, searched}) => {
const MTGMap = ({useColors, currentCoord, handleChange, setOpen, open}) => {
    const [data, setData] = useState([]);
    const [cardData, setCardData] = useState([]);
    const [thisZoom, setThisZoom] = useState(0);
    const [fakeZoom, setFakeZoom] = useState(0);
    const [uniqueData, setUniqueData] = useState([]);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [searched, setSearched] = useState('');
    const [displayData, setDisplayData] = useState('data');
    const changeZoom = (t) => {
      setFakeZoom(t.target.value)
    };

    useEffect(() => {
      if (data.length === 0) {
        fetchAndDecompressData().then(setCardData);
      }
    }, [data]);

    const changeDisplayData = () => {
      setDisplayData(prev => prev === 'data' ? 'unique' : 'data')
    }

    useEffect(() => {
        function handleResize() {
          setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (cardData.length) {
          const { innerWidth: width, innerHeight: height } = window;

          setData(cardData.map((t, i) => {return {...t, 
            color_x: t.color_x*width*0.9 + width*0.05, 
            color_y: t.color_y*height*0.9 + height*0.05, 
            keyword_x: t.keyword_x*width*0.9 + width*0.05, 
            keyword_y: t.keyword_y*height*0.9 + height*0.05, 
            power_x: t.power_x*width*0.9 + width*0.05, 
            power_y: t.power_y*height*0.9 + height*0.05, 
            text_x: t.text_x*width*0.9 + width*0.05, 
            text_y: t.text_y*height*0.9 + height*0.05, 
            type_x: t.type_x*width*0.9 + width*0.05, 
            type_y: t.type_y*height*0.9 + height*0.05, 
            zIndex: 1 + Math.random(),
            display_x: width*(i % 384)/(width/1.95)+ width*0.25, 
            display_y: height*Math.floor(i / 384)/(height/2.7) + height*0.15
          }}));
          setUniqueData(_.uniqBy(cardData.map((t, i) => {return {...t,
            color_x: t.color_x*width*0.9 + width*0.05, 
            color_y: t.color_y*height*0.9 + height*0.05, 
            keyword_x: t.keyword_x*width*0.9 + width*0.05, 
            keyword_y: t.keyword_y*height*0.9 + height*0.05, 
            power_x: t.power_x*width*0.9 + width*0.05, 
            power_y: t.power_y*height*0.9 + height*0.05, 
            text_x: t.text_x*width*0.9 + width*0.05, 
            text_y: t.text_y*height*0.9 + height*0.05, 
            type_x: t.type_x*width*0.9 + width*0.05, 
            type_y: t.type_y*height*0.9 + height*0.05, 
            display_x: width*(i % 384)/(width/1.95)+ width*0.25, 
            display_y: height*Math.floor(i / 384)/(height/2.7) + height*0.15
          }}), 'name'));
        }
        // setData(_.uniqBy(cardData.map((t) => {return {...t, x: t.x*width*0.9 + width*0.05, y: t.y*height*0.9 + height*0.05}}), 'name'));
    }, [cardData]);
    return (
        <div style={{ display: 'flex', height: '100vh', backgroundColor: '#fbfaf2',
          fontSize: '14px',
          fontFamily: 'Montserrat, sans-serif', }}>
          <div className="search-bar-container">
            {open ? <></> : <Search cardNames={uniqueData} setSearched={setSearched} />}
          </div>
          <div className="zoom-container">
            <Slider 
            min={VALUES.scaleExtent[0]} 
            max={VALUES.scaleExtent[1]} 
            defaultValue={0} 
            aria-label="Custom marks" 
            valueLabelDisplay="auto"
            style={{display: 'none'}}
            marks={[{value: VALUES.zoomDisplayImages,label: 'card display',}]} 
            onChange={changeZoom}
            value={thisZoom} />
          </div>
          <div style={{ flexGrow: 1 }}>
            <CanvasPoints data={displayData === 'data' ? data : uniqueData} fullData={data} width={windowDimensions.width} height={windowDimensions.height} values={VALUES} searched={searched} useColors={useColors} setThisZoom={setThisZoom} thisZoom={fakeZoom} setSearched={setSearched} currentCoord={currentCoord}/>
          </div>
          <div style={{
                        position: 'absolute',
                        left: '3%',
                        bottom: '3%',
                        background: '#ccccccbb',
                        padding: '15px',
                        borderRadius: '10px',
                    }}>
                      <Stack direction="row" spacing={1} alignItems="center">
                              How does this webpage work?
                      <IconButton  onClick={() => setOpen(true)}>
                        <InfoIcon />
                    </IconButton>
                    </Stack>
                        <div style={{
                            marginBottom: '10px',  // Add space between components
                        }}>
                            <Stack direction="row" spacing={1} alignItems="center">
                              All printings
                              <Switch sx={{
                                      "&.MuiSwitch-root .MuiSwitch-switchBase": {
                                          color: "#F6DCAC"
                                      },

                                      "&.MuiSwitch-root .Mui-checked": {
                                      color: "#F6DCAC"
                                      },
                                      "& .MuiSwitch-track": {
                                          backgroundColor: "#E6C999", // Background color of the track when unchecked
                                      },
                                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                          backgroundColor: "#D4B383", // Background color of the track when checked
                                      },
                                      }} onChange={changeDisplayData}/>
                              Unique printings
                            </Stack>
                            </div>
                            <div>
                              <Stack direction="row" spacing={1} alignItems="center">
                                  <InputLabel id="demo-simple-select-helper-label" style={{
                                        color: 'black',
                                        fontSize: '14px',
                                        fontFamily: 'Montserrat, sans-serif',
                                    }}>Sort cards by</InputLabel>
                                  <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={currentCoord}
                                      size='small'
                                      style={{
                                        color: 'black',
                                        fontSize: '13px',
                                        fontFamily: 'Montserrat, sans-serif',
                                    }}
                                      onChange={handleChange}
                                  >
                                      {Object.keys(DISPLAYS).map((t) => (
                                          <MenuItem key={t} value={t} style={{
                                            color: 'black',
                                            fontSize: '13px',
                                            fontFamily: 'Montserrat, sans-serif',
                                        }}>{t}</MenuItem>
                                      ))}
                                  </Select>
                              </Stack>
                          </div>
                          </div>
        </div>
      );
}

export default MTGMap;